<template>
	<div class="row mt-4">
		<div class="col-sm-6">
			<b-button
				block
				variant="primary"
				class="mt-2"
				@click="save"
				pill
			>
				Сохранить открытку
			</b-button>
			<a
				:href="download"
				style="display:none;"
				download="image.png"
				ref="link"
				>download link</a
			>
		</div>
		<div class="col-sm-6">
			<div class="tool-card">
				<h5>Сохранить как запись</h5>
				<i>если есть анимации или gif на холсте</i>
				<div class="mb-2 mt-2">Длительность {{ recordTime }} секунд</div>
				<b-form-input
					:disabled="countdown !== 0"
					v-model="recordTime"
					type="range"
					:min="minTime"
					:max="maxTime"
					:step="1"
				></b-form-input>
				
				<b-button
					block
					variant="outline-primary"
					@click="saveToWebm"
					class="mt-2"
					ref="recordBtn"
				>
					{{ btnCurrentText }}
				</b-button>
			</div>
		</div>
		<!-- block with video -->
		<div class="created-video" v-show="showVideo"></div>
		<div class="created-img"  v-show="showImg">
			<img ref="imgTag" src="" alt="">
		</div>
	</div>
</template>

<script>
import { fabric } from "fabric";
import CanvasRecorder from "@/utils/CanvasRecorder";
import watermark from "@/assets/BEST_EDITOR.svg";

export default {
    props:[
        'canvas',
        'isVIP',
    ],
    data(){
        return{
			showImg: false,
			showVideo: false,
			download: "",
			btnTextDefault: "Начать запись",
            btnTextRecord: "Идет сохранение...",
            btnCurrentText: "",
			minTime: 2,
			maxTime: 5,
            recordTime: 5,
			countdown: 0,
			step: 1,
            filename: "busy_motion.mp4"
        }
    },
    mounted(){
        this.btnCurrentText = this.btnTextDefault
    },
    methods:{
        addWatermark() {
			let offset = 20;
			fabric.Image.fromURL(watermark, (img) => {
				console.log(img);
				img.set({
					left: this.canvas.width - img.width - offset,
					top: this.canvas.height - img.height - offset,
					selectable: false,
				});
				this.canvas.add(img);
			});
		},
        removeLastAddedItem() {
			const canvas_objects = this.canvas._objects;
			if (canvas_objects.length !== 0) {
				var last = canvas_objects[canvas_objects.length - 1]; //Get last object
				this.canvas.remove(last);
				this.canvas.renderAll();
			}
		},
		saveToWebm() {
			let video = document.querySelector('.created-video video');
			if(video){
				video.remove();
			}
			if (!this.isVIP) {
				this.addWatermark();
			}
			this.$refs.recordBtn.setAttribute("disabled", true);
			const canvas = document.querySelector("#canvas");
			const recorder = new CanvasRecorder(canvas, 4500000);
			console.log(recorder);
			this.canvas.discardActiveObject();
			recorder.start();
			this.countdown = this.recordTime
			let interval = setInterval(() => {
				if(this.countdown>0){
					console.log(this.countdown)
					this.btnCurrentText = `${this.btnTextRecord} (осталось ${this.countdown--})`;
				}
			}, 1000);
			setTimeout(() => {
				this.$refs.recordBtn.removeAttribute("disabled");
				recorder.stop();
				if(this.showImg === true){
					this.showImg = false;
				}
					this.showVideo = true;
				// Save with given file name
				recorder.save(this.filename);
				if (!this.isVIP) {
					this.removeLastAddedItem();
				}
				clearInterval(interval)
				console.log(this.countdown)

				this.btnCurrentText = this.btnTextDefault;
			}, (this.recordTime) * 1000);
		},
		save() {
			if (!this.isVIP) {
				this.addWatermark();
			}

			setTimeout(() => {
				this.download = this.canvas.toDataURL({
					format: "png",
					quality: 1,
				});
				if (!this.isVIP) {
					this.removeLastAddedItem();
				}

				/////////////////
				// let blob = new Blob([this.download], {type: "octet/stream"});
				// let imgTag = document.querySelector('.created-img img');
				this.$refs.imgTag.src = this.download;
				if(this.showVideo === true){
					this.showVideo = false;
				}
					this.showImg = true;
				
			}, 500);

			setTimeout(() => {
				this.$refs.link.click();
			}, 1000);
		},
		cancelLastAction(){
			this.removeLastAddedItem();
		},
	}
}
</script>

<style>

</style>